/* cs-ship.js - CineStore 3.0 shared dispatch engine (single source of truth).
   ONE place that answers "when does this order dispatch and arrive?" for the
   whole site: the product buy-box (assets/cs-buybox.js) and the homepage Crew
   Favourites bar (sections/cs-home.liquid) both read from here.

   Honesty fix: "now" is computed in Europe/London via Intl.DateTimeFormat, NOT
   the visitor's device clock. An overseas buyer, or anyone with a wrong local
   clock, previously got a false "same-day" promise because the 2pm cutoff was
   measured against their timezone. It is now always measured against UK time.

   Cutoff time + closure (non-working) dates come from window.CS_SHIP_CFG, set by
   snippets/cs-ship-config.liquid. Edit those values there, in one place only. */
(function () {
  var cfg = window.CS_SHIP_CFG || {};
  var cutoffH = (cfg.cutoffH != null) ? cfg.cutoffH : 14;
  var cutoffM = (cfg.cutoffM != null) ? cfg.cutoffM : 0;
  var closures = cfg.closures || [];

  /* Returns a Date whose LOCAL fields (getHours/getDay/getDate...) hold the
     current Europe/London wall-clock time. This lets the existing date maths
     (getHours, toDateString, setDate) stay in London regardless of the device. */
  function londonNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var h = (o.hour === '24') ? 0 : parseInt(o.hour, 10); // some engines emit '24' at midnight
      return new Date(parseInt(o.year, 10), parseInt(o.month, 10) - 1, parseInt(o.day, 10),
                      h, parseInt(o.minute, 10), parseInt(o.second, 10));
    } catch (e) {
      return new Date(); // graceful fallback if Intl/timeZone unsupported
    }
  }

  function ymd(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function isWorking(d) { var g = d.getDay(); if (g === 0 || g === 6) return false; if (closures.indexOf(ymd(d)) > -1) return false; return true; }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function nextWorking(d) { var x = addDays(d, 1); while (!isWorking(x)) x = addDays(x, 1); return x; }
  function pad(n) { return String(n).padStart(2, '0'); }

  /* Canonical dispatch state, in UK time. */
  function getDispatch() {
    var now = londonNow();
    var beforeCut = now.getHours() < cutoffH || (now.getHours() === cutoffH && now.getMinutes() < cutoffM);
    var dispatch = (isWorking(now) && beforeCut) ? new Date(now) : nextWorking(now);
    var sameDay = isWorking(now) && dispatch.toDateString() === now.toDateString();
    var remaining = 0;
    if (sameDay) { var co = new Date(now); co.setHours(cutoffH, cutoffM, 0, 0); remaining = Math.max(0, Math.floor((co - now) / 1000)); }
    return { now: now, sameDay: sameDay, remaining: remaining, dispatch: dispatch, arrival: nextWorking(dispatch) };
  }

  /* Live, ticking dispatch sentence (used on the product page buy-box). */
  function dispatchLineHtml() {
    var s = getDispatch();
    if (s.sameDay) {
      var rem = s.remaining;
      var hh = pad(Math.floor(rem / 3600)); rem %= 3600;
      var mm = pad(Math.floor(rem / 60)); var sc = pad(rem % 60);
      return 'Order within <b>' + hh + ':' + mm + ':' + sc + '</b> for same-day dispatch';
    }
    return 'Order now · dispatched <b>' + fmt(s.dispatch) + '</b>';
  }

  /* Static, non-ticking version (used on the homepage Crew Favourites bar so it
     does not update every second). Same UK-time source, same truth, no countdown. */
  function dispatchLineStaticHtml() {
    var s = getDispatch();
    if (s.sameDay) return 'Order by 2pm, <b>ships today</b>';
    return 'Order now · dispatched <b>' + fmt(s.dispatch) + '</b>';
  }

  window.CSShip = {
    cfg: { cutoffH: cutoffH, cutoffM: cutoffM, closures: closures },
    londonNow: londonNow, ymd: ymd, fmt: fmt, isWorking: isWorking,
    addDays: addDays, nextWorking: nextWorking, getDispatch: getDispatch,
    dispatchLineHtml: dispatchLineHtml, dispatchLineStaticHtml: dispatchLineStaticHtml
  };

  /* Fill any element marked [data-cs-ship-line] (e.g. Crew Favourites cards) with
     the static dispatch line ONCE at load. No interval, so nothing ticks. */
  function mount() {
    var html = dispatchLineStaticHtml();
    var nodes = document.querySelectorAll('[data-cs-ship-line]');
    for (var i = 0; i < nodes.length; i++) { nodes[i].innerHTML = html; }
  }
  if (document.readyState !== 'loading') mount(); else document.addEventListener('DOMContentLoaded', mount);
})();
